module.exports = __webpack_public_path__ + "static/media/LinkedIn_Logo.c3219926.svg";